import { jsx as n } from "react/jsx-runtime";
import { c as p } from "react/compiler-runtime";
import { MenuItem as s } from "@mui/material";
import { forwardRef as f } from "react";
const M = f((m, i) => {
  const e = p(7);
  let o, r;
  e[0] !== m ? ({
    children: o,
    ...r
  } = m, e[0] = m, e[1] = o, e[2] = r) : (o = e[1], r = e[2]);
  let t;
  return e[3] !== o || e[4] !== r || e[5] !== i ? (t = /* @__PURE__ */ n(s, { ref: i, ...r, children: o }), e[3] = o, e[4] = r, e[5] = i, e[6] = t) : t = e[6], t;
});
export {
  M as MenuItem
};
